import { APIClient } from "api/api_helper";
import { VOLUNTEER_API } from "api/url_helper";

// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------

const api = new APIClient();

// ------------------------------------------------------------------
// Volunteer Attachment API
// ------------------------------------------------------------------

export interface StudyICFSelectAllParams {
  otherid?: number | null;
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;
  volunteerid?: number | null;
  studyid?: number | null;
}

export const volunteerICFInfo = {
  // ------------------------------------------------------------------
  // SELECT
  // ------------------------------------------------------------------
  getSelectData: (id: number) => {
    const payload = {
      refid: id,
      attachmenttype: "RCF",
    }

    return api.create(
      VOLUNTEER_API.VOLUNTEER_ATTACHMENT_API +
      "Select",
      payload
    );
  },
};
